module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "width": "500px"
    }
  }, [_c('v-chart', {
    attrs: {
      "height": "300",
      "width": "200",
      "data": _vm.data,
      "padding": 10
    }
  }, [_c('v-guide', {
    attrs: {
      "type": "text",
      "content": "销售额",
      "top": true,
      "position": ['40%', '45%']
    }
  }), _vm._v(" "), _c('v-guide', {
    attrs: {
      "type": "text",
      "content": _vm.sum,
      "top": true,
      "position": ['39%', '55%']
    }
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "showTitle": false
    }
  }), _vm._v(" "), _c('v-legend', {
    attrs: {
      "useHtml": true,
      "position": "right-top",
      "reactive": true,
      "offset": [20, 30],
      "itemMarginBottom": 40,
      "containerTpl": _vm.containerTplLegend,
      "itemTpl": _vm.itemTplLegend
    }
  }), _vm._v(" "), _c('v-coord', {
    attrs: {
      "type": "theta",
      "innerRadius": "0.7"
    }
  }), _vm._v(" "), _c('v-pie', {
    attrs: {
      "position": "value",
      "color": "type",
      "shape": "sliceShape"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a44fd8d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/testviser/index.vue
// module id = 2378
// module chunks = 1